import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboardIcon, ClipboardListIcon, Building2Icon, UsersIcon, CalendarDaysIcon, BuildingIcon } from 'lucide-react';
const NAV = [{
  to: '/',
  label: 'Overview',
  icon: LayoutDashboardIcon,
  end: true
}, {
  to: '/proposals',
  label: 'Proposal Workflow',
  icon: ClipboardListIcon
}, {
  to: '/properties',
  label: 'Active / Sold',
  icon: Building2Icon
}, {
  to: '/leads',
  label: 'Leads',
  icon: UsersIcon
}, {
  to: '/social',
  label: 'Social Planner',
  icon: CalendarDaysIcon
}];
export function Sidebar() {
  return <aside className="flex w-60 shrink-0 flex-col border-r border-slate-200 bg-brand text-white" data-id="element-31" data-mp="35rge8tkbb4p4">
      <div className="flex items-center gap-2.5 px-5 py-5" data-id="element-32" data-mp="3aq1geyj4jyg7">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-accent" data-id="element-33" data-mp="3ao72i469t6lm">
          <BuildingIcon className="h-5 w-5 text-white" data-id="element-34" data-mp="1bf07lrnltojq" />
        </div>
        <div className="leading-tight" data-id="element-35" data-mp="1gdblqekxml7r">
          <div className="text-sm font-bold tracking-tight" data-id="element-36" data-mp="1ge3fdjuyy8ve">Meridian CRE</div>
          <div className="text-[11px] text-white/50" data-id="element-37" data-mp="1w1njnj0rgjno">Deal Workspace</div>
        </div>
      </div>

      <nav className="mt-2 flex-1 space-y-0.5 px-3" data-id="element-38" data-mp="1r7sx87trtqkw">
        {NAV.map(item => <NavLink key={item.to} to={item.to} end={item.end} className={({
        isActive
      }) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition ${isActive ? 'bg-white/15 text-white' : 'text-white/70 hover:bg-white/10 hover:text-white'}`} data-id="element-39" data-mp="1mb2n014ndp7e">
            <item.icon className="h-[18px] w-[18px]" data-id="element-40" data-mp="25xgzbb9s0t9o" />
            {item.label}
          </NavLink>)}
      </nav>

      <div className="border-t border-white/10 p-4 text-[11px] leading-relaxed text-white/50" data-id="element-41" data-mp="20ynndna51abm">
        <p className="font-semibold text-white/70" data-id="element-42" data-mp="ujv2d3xodndl">Notified on every request</p>
        <p data-id="element-43" data-mp="pjqto030dwxx">Faraz · Michael · Simon</p>
      </div>
    </aside>;
}